import { connection, deleteRecord, findRecord, insertRecord, transferMoney, updateRecord, updateWalletsForTransfer } from "./services";
import { showSwalError } from "../utilities/swal";
import axios from "axios";
import Cookie from "js-cookie";
import { sendRequest } from "../utilities/useAxios";

const inventory = async (muid) => {
  let data = await findRecord("Wallets", {
    conditions: `uid/=/${muid}`,
  });
  return data[0]["current_inventory"];
};

const Charg = async (cost) => {
  if (cost == 0) {
    showSwalError("\n مبلغ را وارد کنید");
  } else {
    let form = new FormData();
    form.append("factor_id", -1);
    form.append("pay_amount", `${cost}`);
    form.append("callback", "customer-panel/transactions");
    form.append("usertoken", Cookie.get("login_key"));
    sendRequest("payfactor", form)
      .then(({ data }) => {
        if (data.state == 1) {
          window.location.href = `http://${data.data.url}`;
        } else {
          showSwalError("\n مشکلی به وجود آمده لطفا دوباره امتحان کنید");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

async function TransferToCard(CartNumber, price, muid) {
  let transaction = false;
  let fromWalletId = await findRecord("Wallets", {
    conditions: `uid/=/${muid}`,
  });
  let toWalletId = await findRecord("Wallets", {
    conditions: `uid/=/0`,
  });
  let current_inventory = fromWalletId[0]["current_inventory"];

  if (current_inventory <= 0) {
    showSwalError("\n موجودی کافی نیست");
  } else {
    let mtm = new Date();
    mtm = parseInt(mtm.getTime() / 1000);
    let res = await insertRecord("wallets_transactions", {
      type: 3,
      transaction_type: 0,
      amount: price,
      from_wallet_id: fromWalletId[0]["id"],
      to_wallet_id: toWalletId[0]["id"],
      factor_id: 0,
      mtm: mtm,
      tparams: CartNumber,
      main_status: 2,
    });
    if (!res.status) return false;
    let result = res.result.id;
    res = updateWalletsForTransfer(fromWalletId[0]["id"], toWalletId[0]["id"], price);
    return res ? result : false;
  }

  return transaction;
}

const TransactionRecords = async (id) => {
  let records;

  let walletId = await findRecord("Wallets", { conditions: `uid/=/${id}` });
  let Payment = await findRecord("Wallets_transactions", {
    conditions: `from_wallet_id/=/${walletId[0]["id"]}`,
  });
  let Deposit = await findRecord("Wallets_transactions", {
    conditions: `to_wallet_id/=/${walletId[0]["id"]}`,
  });

  records = Payment.concat(Deposit);
  records.sort((a, b) => b.mtm - a.mtm);

  return records;
};

const date = (TimeStamp) => {
  let options = { year: "numeric", month: "numeric", day: "numeric" };
  let date = new Date(parseInt(TimeStamp) * 1000);

  let FaDate = date.toLocaleDateString("fa-IR", options);
  FaDate.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
  return [date.getHours(), date.getMinutes(), FaDate];
};

export { TransferToCard, TransactionRecords, date, inventory, Charg };
